import React from 'react';
var useStyles = _ref => {
  var {
    size = 36,
    defaultWidth,
    defaultHeight
  } = _ref;
  return React.useMemo(() => ({
    height: "".concat(size !== null && size !== void 0 ? size : defaultHeight, "px"),
    width: 'unset',
    aspectRatio: "".concat(defaultWidth, " / ").concat(defaultHeight)
  }), [size, defaultWidth, defaultHeight]);
};
export default useStyles;